/**
 * Sections
 */
export const SET_MODULO = "SET_MODULO";
export const CREATE_MODULO = "CREATE_MODULO";
export const MODULOS_RECEIVED = "MODULOS_RECEIVED";
export const SET_SECTION_TEST = "SET_SECTION_TEST";
export const SET_PROPERTY_MODULO = "SET_PROPERTY_MODULO";
